// Header WhatsApp button: pulled forward from the WhatsApp phase, header only.
//
// Stock Horizon's header-actions snippet has no block-based extension point
// (blocks/header.liquid renders it via a plain `render`, not a swappable
// static block), so this appends a real <a> as the last child of
// <header-actions>, same pattern as gsb-header-logo.js. Number and message
// come from owner-editable theme settings, not hardcoded here.
(function () {
  function addButton(actions) {
    if (actions.querySelector('.gsb-wa-header')) return;

    var settings = window.gsbWhatsappSettings || {};
    var number = settings.number;
    if (!number) return;

    var message = settings.message || '';
    var href = 'https://wa.me/' + number + (message ? '?text=' + encodeURIComponent(message) : '');

    var link = document.createElement('a');
    link.className = 'gsb-wa-header header-actions__action';
    link.href = href;
    link.target = '_blank';
    link.rel = 'noopener';
    link.setAttribute('aria-label', 'Chat on WhatsApp');
    link.innerHTML =
      '<svg class="gsb-wa-header__icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" /></svg>' +
      '<span class="gsb-wa-header__label">WhatsApp</span>';

    actions.appendChild(link);
  }

  function run() {
    document.querySelectorAll('header-actions').forEach(addButton);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
})();
